import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
 }


html {
  font-size: 16px;
  // overflow-x: hidden; 
}

body {
  overflow-x: hidden;
  scrollbar-color: rgb(98 84 243);
  scrollbar-width: thin;
  color:${({ theme }) => theme.colors.title_green};
}

body::-webkit-scrollbar {
  width: 1.5rem;
}

body::-webkit-scrollbar-track {
   background-color: rgb(24 24 29);
}

body::-webkit-scrollbar-thumb {
 
  background: #fff;
    border: 5px solid transparent;
    border-radius: 9px;
    background-clip: content-box;
}

h1, h2, h3, .card-title{
  color:${({ theme }) => theme.colors.title_green};
  font-size: 32px;
  line-height: 42px;
  font-weight: 500;
}

.small-title{
  color:${({ theme }) => theme.colors.title_green};
  font-size: 19px;
  line-height: 27px;
  font-weight: 600;
  @media (max-width:${({ theme }) => theme.media.tab}) {
    font-size: 17px;
    line-height: 25px;
  }
}


.fw-normal{
  font-weight: 600;
}

.fw-bold{
  font-weight: bold;
}



.flex{
  display: flex;
}

.flex-row{
  flex-direction: row;
}

.flex-col{
  flex-direction: column;
}

.items-center{
  align-items: center;
}

.items-start{
  align-items: flex-start;
}

.items-end{
  align-items: flex-end;
}

.justify-center{
  justify-content: center;
}

.justify-space-between{
  justify-content: space-between;
}

.justify-start{
  justify-content: flex-start;
}

.justify-end{
  justify-content: flex-end;
}

.flex-wrap{
  flex-wrap: wrap;
}

.mx-auto{
  margin-left: auto;
  margin-right: auto;
}

.max-full{
  max-width: 100%;
}

.w-full{
  width: 100%;
}

.img-cover{
  object-fit: cover;
}

.h-full{
  height: 100%;
}

.text-center{
  text-align: center;
}

.text-left{
  text-align: left;
}

p {
  font-size: 16px;
  margin-top: 12px;
  font-weight:400;
  line-height: 180%;
}

a {
  text-decoration: none;
}

.green-link{
  color: ${({ theme }) => theme.colors.light_green};
  font-weight: 600;
}


li {
  list-style: none;
}

.grid {
  display: grid;
  gap: 9rem;
}

.grid-two-column {
  grid-template-columns: repeat(2, 1fr);
}

.grid-three-column {
  grid-template-columns: repeat(3, 1fr);
}

.grid-four-column{
   grid-template-columns: 1fr 1.2fr .5fr .8fr ;
}

.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.small, small{
  font-size: 14px;
}

.uppercase{
  text-transform: uppercase;
}

.form-group .form-control{
  line-height: 29px;
  padding: 2px 12px;
  border-radius: 6px;
  border: 1px solid #DDEDD0;
  ${({ status, theme }) =>
      status === 'failure' && `border: 1px solid ${theme.colors.actionOrange};`}
}

.form-control:focus{
  border-color: #6EA44C;
}


.form-group .form-control::placeholder, .form-group .input-blank::placeholder{
  color: #004D37;
  font-weight: 400;
}

.taxonomy-list{
  gap: 8px;

  li {
    color: white;
    font-weight: 600;
    
    border-radius: 25px;
    line-height: 28px;
    padding: 0px 10px;

    a {
      color: white;
    }
  }
}
.category-list {
  background-color: ${({ theme }) => theme.colors.title_green};
}

.landscape-list{
  background-color: ${({ theme }) => theme.colors.light_green};
}


.sticky{
  position: fixed;
  top: 0;
  background-color: #fff;
  width: 100%;
  z-index: 999;
  animation: headermove 0.4s;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;

}

.company-logo-container .slick-track{
  display: flex;
  align-items: center;
}

@keyframes headermove {
  from {top: -80px;}
  to {top: 0px;}
}


/* stepform  starts*/
.input-box-section {
    flex: 1;
    position: relative; 
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
     max-height: 200px; 
    overflow-y: auto; 
    overflow-x: hidden;
    background: white;
    border: 1px solid #ccc;
    z-index: 9999; 
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
}

.input-box-section label{
  line-height: 180%;
  font-weight: 600;
  margin-bottom: 4px;
}
.form-control{
  display: flex;
  font-size: 16px;
  height: 37px;
  line-height: 27px;
  width: 100%;
  padding: 4px 12px;
  border: 1px solid #CECECE;
  border-radius: 6px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.title_green};
  &:focus{
    outline: 0;
  }
  &::placeholder{
    color: ${({ theme }) => theme.colors.lightGray};
  }
}

.input-group{
  .input-group-prepend{
    right: 0;
    top: 46px;
    transform: translateY(-50%);
    padding: 0 12px;
    line-height: 1;
    z-index: 2;
    height: 16px;
    cursor: pointer;
  }
  .form-control{
    padding-right: 35px;
  }
}


.radio-box{
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid #DDEDD0;
    border-radius: 50%;
  }

  button{
    border: 0 none;
    background-color: none;
  }

  /* When the radio button is checked, add a blue background */
  input{
    position: absolute;
    opacity: 0;
    cursor: pointer;
    &:checked ~ .checkmark {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cellipse cx='9.94924' cy='10' rx='9.94924' ry='10' fill='%236EA44C'/%3E%3Cpath d='M4.97461 9.28561L8.02285 12.6558C8.29738 12.9593 8.7703 12.9706 9.05895 12.6804L15.2792 6.42847' stroke='%23F8FBF6' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

}
.form-section .two-col {
  gap: 8px;
  @media (max-width:${({ theme }) => theme.media.tab}) {
    flex-direction: column;
    gap: 24px;
  }
}
.input-error{
  border-color: #DD6B17;
  color: #DD6B17;
}
.error-text{
  color: #DD6B17;
  line-height: 180%;
  margin-top: 5px;
  font-weight: 600;
}
.text-white{
  color: white;
}

.disabled{
  border-color: #BABABA;
  color: #BABABA;
  background-color: white;
  &::placeholder{
    color: #BABABA;
  }
}

button{
  border: 0 none;
 
  cursor: pointer;
}

button.disabled{
  color: white;
  background-color: #CECECE;
  cursor: default;
  &:hover{
    background-color: #CECECE;
  }
}

.consent-box label a {
  font-weight: 600;
  color:${({ theme }) => theme.colors.title_green};
}
.step-nav{
  margin-top: 50px;
  width: 100%;
  max-width: 440px;
  gap: 13px;
  .bullet{
    background: #DDEDD0;
    width: 100%;
    height: 4px;
  }
  .current{
    background: #6EA44C;
  }
}
.formnextprev {
  top: -50px;
  button{
    line-height: 180%;
    font-weight: 600;
    padding: 5px;
    gap: 4px;
    border: 0;
    background: none;
    cursor: pointer;
    color:${({ theme }) => theme.colors.title_green};
  }
  
  .prev-btn{
    align-self: flex-start;
    left: -10px;
  }
  .next-btn{
    position: absolute;
    right: -10px;
    top: 0;
  }
  .disable{
    color: #BABABA;
    cursor: default;
  }
  @media (max-width:${({ theme }) => theme.media.tab}) {
    // top: 13px;
  }
}
.hidden{
  display: none;
}
.fee-n-box{
  max-width: 225px;
  right: 4.8rem;
  gap: 8px;
  border-radius: 8px;
  top: 70px;
  box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.07);
  padding: 8px 12px;
  .big-txt{
    font-weight: 600;
    gap: 4px;
  }
  .tooltip-box{
    display: none;
    padding: 20px;
    box-shadow: 2px 4px 15px 0px rgba(0, 0, 0, 0.05);
    background: white;
    border-radius: 8px;
    position: absolute;
    font-weight: 400;
    width: 190px;
  }
  .tooltip-ic{
    font-size: 18px;
    width: 20px;
    height: 20px;
    display: inline-block;
    line-height: 12px;
    color: ${({ theme }) => theme.colors.title_green};
    &:hover + .tooltip-box{
      display: block;
    }
  }
  @media (max-width:${({ theme }) => theme.media.tab}) {
    top: 0;
    right: 0;
    .tooltip-box{
      display: none;
      padding: 20px;
      box-shadow: 2px 4px 15px 0px rgba(0, 0, 0, 0.05);
      background: white;
      border-radius: 8px;
      position: absolute;
      font-weight: 400;
      width: 190px;
    }
  }
}

.hide-desk{
  display: none;
}


.show-mobile{
  display: none;
}
.show-tab, .show-flex-tab{
  display: none;
}
/* stepform ends */


.modal-box-class {
  padding: 50px 43px 50px 50px;
  background-color: white;
  position: fixed;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  z-index: 9999;
  border-radius: 20px;
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
      top: auto;
      bottom: 0;
      max-height: 98%;
      transform: translateY(0);
      transform: translateX(-50%);
      border-radius: 10px 10px 0 0;
  }
}
.modal-close-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #f8fbf6;
  position: absolute;
  font-size: 20px;
  font-weight: bold;
  right: 17px;
  top: 17px;
  color: #004d37;
  &:hover {
      border: 1px solid #ccc;
  }
}

/* ===========================================
/* media queries  
======================================= */
/* px  */
/* rem  */
/* em  */
/* 1500px */

//1023px
@media (max-width:${({ theme }) => theme.media.tab}) {
  
  .hide-tab{
    display: none;
  }
  .show-tab{
    display: block;
  }
  .show-flex-tab{
    display: flex;
  }

  .grid-two-column, .grid-three-column, .grid-four-column{
    grid-template-columns: 1fr;
  }
  h1, h2, h3, .card-title{
    font-size: 28px;
    line-height: 38px;
  }
  html, p{
    font-size: 14px;
  }
}

@media (max-width:${({ theme }) => theme.media.mobile}) {

  .hide-mobile{
    display: none;
  }

  .show-mobile{
    display: inline-block;
  }
  .grid{
    gap: 3.2rem;
  }

  .grid-two-column, .grid-three-column, .grid-four-column{
    grid-template-columns: 1fr;
  }
}


`;
